import ITaskTemplate from "models/tasks/ITaskTemplate";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useEffect, useState } from "react";

type UseTaskTemplateProps = {
    taskId?: number | null,
    templateId?: number | null,
    refreshIndex?: number
};

type UseTaskTemplateResult = [
    ITaskTemplate | null,
    boolean,
    string
];
type UseTaskTemplateSignature = (props: UseTaskTemplateProps) => UseTaskTemplateResult;

const useTaskTemplate: UseTaskTemplateSignature = (props) => {
    const { taskId, templateId, refreshIndex } = props;

    const [ value, setValue ] = useState<ITaskTemplate | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ error, setError ] = useState<string>('');

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);
    
    useEffect(() => {        
        if (!taskId && !templateId) return;
        const controller = new AbortController();             

        (async () => {
            if (user && user.access_token){
                setLoading(true);
                try {
                    let uri: string = '';
                    if (templateId && templateId !== 0)
                        uri = `/api/v3/templates/tasks/${templateId}`;
                    else 
                        uri = `/api/v3/tasks/${taskId}/template`;

                    const resp = await fetcher(uri, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        switch (resp.status) {
                            case 404:
                                setValue(null);
                                break;
                            default:
                                break;
                        }
                    }

                    const data = await resp.json() as ITaskTemplate;
                    setValue(data);
                } catch (err) {
                    
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        })();

        return () => controller.abort();
    }, [ taskId, templateId, user, refreshIndex ]);

    return [
        value,
        loading,
        error
    ];
};

export default useTaskTemplate;